import { css } from '@emotion/react'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { usePinosTerritorioQuery, usePoligonosTerritorioQuery } from 'graphql/hooks.generated'
import { useMemo } from 'react'
import { useParams } from 'react-router'
import { emptyArrayOf } from 'util/array'

import { MapaViewSidebar } from './components/MapaViewSidebar'
import { PinoTerritorioModal } from './components/PinoTerritorioModal'
import { TerritorioMapa } from './components/TerritorioMapa'
import { convertFilterToQueryInput } from './converter-territorioMapa'
import { useTerritorioMapaCache } from './hooks/useTerritorioMapaCache'
import { MapaBuscaPanel } from './mapa-busca/MapaBuscaPanel'
import { getFilterDefaultValues } from './mapa-busca/utils-territorioMapaBusca'
import { MapaCamadasPanel } from './mapa-camadas/MapaCamadasPanel'
import { MapaSidebarNavItemEnum, TerritorioCamadaQueryModel } from './model-territorioMapa'

export function TerritorioMapasView() {
  const { imovelId } = useParams<{ imovelId?: string }>()
  const { acesso } = useAcessoLotacaoOrEstagio()

  const defaultFilter = useMemo(() => getFilterDefaultValues(acesso), [acesso])

  const { filter, updateFilter } = useTerritorioMapaCache(defaultFilter)

  const { data: pinos, loading: isLoading } = usePinosTerritorioQuery({
    variables: {
      input: convertFilterToQueryInput(filter),
    },
  })

  const { data: camadas, refetch } = usePoligonosTerritorioQuery()

  return (
    <div css={styles.root}>
      <MapaViewSidebar
        panels={{
          [MapaSidebarNavItemEnum.BUSCA]: (
            <MapaBuscaPanel defaultValues={defaultFilter} initialValues={filter} onSubmit={updateFilter} />
          ),
          [MapaSidebarNavItemEnum.CAMADAS]: (
            <MapaCamadasPanel
              camadas={camadas?.poligonosTerritorio ?? emptyArrayOf<TerritorioCamadaQueryModel>()}
              refetch={refetch}
            />
          ),
          [MapaSidebarNavItemEnum.AJUDA]: <div />,
        }}
      />
      <TerritorioMapa
        pinosTerritorio={pinos?.pinosTerritorio}
        isLoading={isLoading}
        filtrosAvancados={filter.filtrosAvancados}
      />
      {imovelId && <PinoTerritorioModal imovelId={imovelId} />}
    </div>
  )
}

const styles = {
  root: css`
    display: grid;
    grid-template-columns: auto 1fr;
  `,
}
